export default __webpack_public_path__ + "static/media/bronze-wheel-two.d1881515.svg";